export enum StoreName {
  AntipatternStore = 'AntipatternStore',
  AssetsStore = 'AssetsStore',
  ServiceWorkerCommonStore = 'ServiceWorkerCommonStore',
  StudentStore = 'StudentStore',
  UserStore = 'UserStore',
  ViewStore = 'ViewStore',
}
